import { LoaderPinwheel, Ruler, LifeBuoy } from "lucide-react";

const S = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };

const CUSTOM = {
  tire: (p) => (
    <svg viewBox="0 0 24 24" width={p.size || 24} height={p.size || 24} {...S}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="4.2" />
      {Array.from({ length: 8 }).map((_, i) => (
        <line key={i} x1="11.9" y1="2.2" x2="11.9" y2="4.6" transform={`rotate(${i * 45} 12 12)`} />
      ))}
    </svg>
  ),
  puncture: (p) => (
    <svg viewBox="0 0 24 24" width={p.size || 24} height={p.size || 24} {...S}>
      <circle cx="12" cy="13.5" r="8" />
      <circle cx="12" cy="13.5" r="3.6" />
      <path d="M15.5 1.5 L13 6.2 M14 3.4 l2.2 -1.2" />
      <path d="M6.2 2.6 a4 4 0 0 1 2.4 -1.2 M3.4 5.4 a4 4 0 0 1 1.4 -1.9" />
    </svg>
  ),
  tpms: (p) => (
    <svg viewBox="0 0 24 24" width={p.size || 24} height={p.size || 24} {...S}>
      <path d="M7 17 V11.5 A5 5 0 0 1 17 11.5 V17" />
      <path d="M4.5 17 h15" />
      <path d="M12 8.2 v3.2" />
      <circle cx="12" cy="14.2" r="0.4" fill="currentColor" stroke="none" />
    </svg>
  ),
  battery: (p) => (
    <svg viewBox="0 0 24 24" width={p.size || 24} height={p.size || 24} {...S}>
      <rect x="3" y="8" width="18" height="11" rx="2.2" />
      <path d="M7 8 V5.6 M17 8 V5.6" />
      <path d="M8.2 13.5 h3.2 M9.8 11.9 v3.2" />
      <path d="M14.2 13.5 h2.6" />
    </svg>
  ),
  sensor: (p) => (
    <svg viewBox="0 0 24 24" width={p.size || 24} height={p.size || 24} {...S}>
      <circle cx="12" cy="15" r="4.2" />
      <circle cx="12" cy="15" r="1" fill="currentColor" stroke="none" />
      <path d="M12 10.8 V8.6" />
      <path d="M7.8 6.4 a6.5 6.5 0 0 1 8.4 0 M5.4 3.6 a10 10 0 0 1 13.2 0" />
    </svg>
  ),
};

const LUCIDE = {
  balancing: LoaderPinwheel,
  ruler: Ruler,
  other: LifeBuoy,
};

export const SERVICE_ICON_BY_SLUG = {
  "tire-change": "tire",
  "puncture-repair": "puncture",
  tpms: "tpms",
  "tpms-replacement": "sensor",
  balancing: "balancing",
  batteries: "battery",
  "tire-size-help": "ruler",
  "other-services": "other",
};

export default function ServiceIcon({ icon, size = 24, className = "" }) {
  if (CUSTOM[icon]) return <span className={`inline-flex ${className}`}>{CUSTOM[icon]({ size })}</span>;
  const L = LUCIDE[icon] || LifeBuoy;
  return <L size={size} className={className} />;
}
